export default "__VITE_ASSET__BTHvFluq__"